import request from './index'

export interface AdminLoginParams {
  username?: string
  password?: string
}

export const adminLogin = (data: AdminLoginParams) => {
  return request.post('/admin/login', data)
}

export const getAdminUsers = (params: { page: number; pageSize: number; keyword: string; sortField?: string; sortOrder?: string }) => {
  return request.get('/admin/users', { params })
}

export const updateUserAudit = (id: number, is_bind: number) => {
  return request.put(`/admin/users/${id}/audit`, { is_bind })
}

export const updateUserPermission = (id: number, data: { state?: number; is_hw?: number; json_condition?: string }) => {
  return request.put(`/admin/users/${id}/permission`, data)
}

export const getDistrictPlateTree = () => {
  return request.get('/admin/districts/tree')
}

export const getUserDataPermissions = (userId: number) => {
  return request.get(`/admin/users/${userId}/data-permissions`)
}

export const saveUserDataPermissions = (userId: number, permissions: { district_id: number, plate_id: number }[]) => {
  return request.put(`/admin/users/${userId}/data-permissions`, { permissions })
}

export const getPrivilegeList = () => {
  return request.get('/admin/privileges')
}

export const getUserPrivileges = (userId: number) => {
  return request.get(`/admin/users/${userId}/privileges`)
}

export const saveUserPrivileges = (userId: number, privileges: { privilege_id: number, start_time: number | null, expires_time: number | null }[]) => {
  return request.put(`/admin/users/${userId}/privileges`, { privileges })
}

// CRM管理 - 获取经纪人客户统计
export const getBrokerClientStatistics = (params?: { page?: number; pageSize?: number; keyword?: string }) => {
  return request.get('/admin/crm/broker-statistics', { params })
}

// CRM管理 - 获取经纪人列表
export const getBrokerList = () => {
  return request.get('/admin/crm/brokers')
}

// CRM管理 - 获取指定经纪人的客户列表
export const getBrokerClients = (brokerId: number, params: { page?: number; pageSize?: number; keyword?: string; status?: number }) => {
  return request.get(`/admin/crm/brokers/${brokerId}/clients`, { params })
}

// CRM管理 - 获取指定经纪人的客户详情（含VIP记录）
export const getBrokerClientDetail = (brokerId: number, clientId: number) => {
  return request.get(`/admin/crm/brokers/${brokerId}/clients/${clientId}`)
}

// CRM管理 - 获取指定经纪人的统计
export const getBrokerStatistics = (brokerId: number) => {
  return request.get(`/admin/crm/brokers/${brokerId}/statistics`)
}
